(() => {
  function holidays(y) {
    const a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),month=Math.floor((h+l-7*m+114)/31),day=(h+l-7*m+114)%31+1;
    const easter=new Date(Date.UTC(y,month-1,day));
    const set=new Set(['01-01','05-01','05-08','07-14','08-15','11-01','11-11','12-25'].map(s=>y+'-'+s));
    for(const offset of [1,39,50]){const date=new Date(easter);date.setUTCDate(date.getUTCDate()+offset);set.add(date.toISOString().slice(0,10));}
    return set;
  }
  function addBusinessDays(start,n) {
    const date=new Date(start);
    while(n){date.setUTCDate(date.getUTCDate()+1);if(date.getUTCDay()!==0&&date.getUTCDay()!==6&&!holidays(date.getUTCFullYear()).has(date.toISOString().slice(0,10)))n--;}
    return date;
  }
  function update() {
    const parts=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Paris',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
    const p=Object.fromEntries(parts.map(x=>[x.type,x.value]));
    const today=new Date(Date.UTC(+p.year,+p.month-1,+p.day));
    for(const el of document.querySelectorAll('[data-hw-delivery]')){
      const fmt=new Intl.DateTimeFormat(el.dataset.locale||'fr',{day:'numeric',month:'long',timeZone:'UTC'});
      el.querySelector('[data-hw-delivery-text]').textContent=el.dataset.template.replace('{start}',fmt.format(addBusinessDays(today,6))).replace('{end}',fmt.format(addBusinessDays(today,9)));
    }
  }
  if(!window.hwDeliveryEstimateLoaded){window.hwDeliveryEstimateLoaded=true;document.addEventListener('shopify:section:load',update);document.addEventListener('visibilitychange',()=>{if(!document.hidden)update();});}
  update();
})();
